import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { bindPropertyAttachmentsOptions } from '../../../../helpers/ui/blockHelpers';
import AttachmentsStep from '../../../CompensationContainer/Steps/AttachmentsStep';
import { uploadActions } from '../../../../redux/modules/propertyClaim';
import { ATTACHMENT_MAX_SIZE, ATTACHMENT_TYPES, ATTACHMENT_VALID_MIME_TYPES } from '../../../../constants';
import useDeviceResize from '../../../../hooks/useDeviceResize';

const {
  PASSPORT,
  OTHER,
  POWER_OF_ATTORNEY,
  OWNER_CERTIFICATE,
} = ATTACHMENT_TYPES;

const attachmentConstraints = {
  maxSize: ATTACHMENT_MAX_SIZE,
  validMimeTypes: ATTACHMENT_VALID_MIME_TYPES,
  requiredTypes: [
    OWNER_CERTIFICATE,
  ],
  maxNumberLimits: {
    [PASSPORT]: 10,
    [OTHER]: 10,
  },
};

const getValidationRules = (data) => {
  const { isOtherApplicant, isPhysicalEntity, isOtherPaymentReceiver } = data;

  return isOtherPaymentReceiver || (isOtherApplicant && isPhysicalEntity)
    ? {
      ...attachmentConstraints,
      requiredTypes: attachmentConstraints.requiredTypes.concat(POWER_OF_ATTORNEY),
    }
    : attachmentConstraints;
};

const PropertyAttachmentStep = ({
  goNext,
  step,
  goPrevious,
  params: { setStepNavigationBox, scrollTo },
}) => {
  const { t } = useTranslation();
  const isDeviceLgSize = useDeviceResize('lg');
  const { attachments } = useSelector((store) => store.propertyClaim, shallowEqual);

  return (
    <AttachmentsStep
      initialData={attachments}
      setStepNavigationBox={setStepNavigationBox}
      loadingProgress={false}
      isDeviceLgSize={isDeviceLgSize}
      goPrevious={goPrevious}
      scrollTo={scrollTo}
      attachments={attachments}
      step={step}
      goNext={goNext}
      uploadActions={uploadActions}
      attachmentConstraints={attachmentConstraints}
      getValidationRules={() => getValidationRules(attachments)}
      options={
      bindPropertyAttachmentsOptions(
        attachments,
        t,
      )
      }
    />
  );
};

PropertyAttachmentStep.propTypes = {
  goNext: PropTypes.func.isRequired,
  step: PropTypes.shape({
    n: PropTypes.number.isRequired,
  }).isRequired,
  goPrevious: PropTypes.func.isRequired,
  params: PropTypes.shape({
    setStepNavigationBox: PropTypes.func.isRequired,
    scrollTo: PropTypes.func.isRequired,
  }).isRequired,
};

export default PropertyAttachmentStep;
